import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { productAPI } from '../../api';
import { useGenericWebSocket } from '../../hooks/useGenericWebSocket';
import toast, { Toaster } from 'react-hot-toast';

export default function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [masterProducts, setMasterProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, pages: 1, total: 0 });

  const fetchProducts = async (params = {}) => {
    setLoading(true);
    try {
      // Handle both numeric page argument or params object
      const requestParams: any = typeof params === 'number' 
        ? { page: params, search: '', status: 'all' } 
        : { page: 1, ...params };

      const userDetails = JSON.parse(localStorage.getItem('seller') || '{}');

      const response = await productAPI.getAll({
        page: requestParams.page,
        limit: 10,
        search: requestParams.search || '',
        status: requestParams.status || 'all',
        seller_id: userDetails._id || '',
        sortBy: requestParams.sortBy || '_id',
        sortOrder: requestParams.sortOrder || 'desc'
      });
      
      
      if (response.data.response === "S") {
        setProducts(response.data.data);
        setMasterProducts(response.data.data);
        
        if (response.data.pagination) {
          setPagination(response.data.pagination);
        } else {
          // Fallback if backend doesn't return pagination metadata yet
          setPagination({ 
            page: requestParams.page, 
            pages: 1, 
            total: response.data.data.length 
          });
        }
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  // Listen to GlobalNotifications for new products
  useGenericWebSocket<any>('global_notifications', (operation, document, collection) => {
    if (operation === 'insert' && document.type === 'product_added') {
      toast.success(`Admin added a new product: ${document.productName}`, {
        duration: 5000,
        position: 'top-right',
        style: {
          fontWeight: '500',
          fontFamily: '"Poppins", sans-serif',
        },
      });
      // Optionally refresh products if user is on products page
      // fetchProducts();
    }
  });

  // Helpers to update the master list
  const addDummyProduct = (product) => {
    setMasterProducts(prev => [product, ...prev]);
    setProducts(prev => [product, ...prev]);
  };

  const updateProduct = (productId, updates) => {
    setMasterProducts(prev => prev.map(p => p._id === productId ? { ...p, ...updates } : p));
    setProducts(prev => prev.map(p => p._id === productId ? { ...p, ...updates } : p));
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
      <Toaster />
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <div className="main-content" style={{ display: 'flex', flexDirection: 'column' }}>
        <Topbar onMenuClick={() => setMobileOpen(true)} />
        <main style={{ flex: 1, padding: '18px 15px' }} className="fade-in">
          <Outlet context={{ 
            products, setProducts, loading, setLoading, 
            pagination, setPagination, fetchProducts, 
            addDummyProduct, updateProduct
          }} />
        </main>
      </div>
    </div>
  );
}
